import Health_Insurance_Icon from 'src/assets/My_Policies_Images/Health_Insurance.svg'
import Car_Insurance_Icon from 'src/assets/My_Policies_Images/Car_Insurance.svg'
import Bike_Insurance_Icon from 'src/assets/My_Policies_Images/Bike_Insurance.svg'
import Life_Insurance_Icon from 'src/assets/My_Policies_Images/Life_Insurance.svg'
import BikeInsuranceLogo from 'src/assets/My_Policies_Images/bikeInsurance.svg'
import LifeInsurance from 'src/assets/My_Policies_Images/lifeInsurance.svg'
import AccidentalInsurance from 'src/assets/My_Policies_Images/accidentalInsurance.svg'
import HomeInsurance from 'src/assets/My_Policies_Images/homeInsurance.svg'
import PetInsurance from 'src/assets/My_Policies_Images/petInsurance.svg'
import TravelInsurance from 'src/assets/My_Policies_Images/travelInsurance.svg'

const UploadPolicyInsuranceTypes = {
  health: 'HEALTH',
  car: 'CAR',
  bike: 'BIKE',
  life: 'LIFE',
  others: 'OTHERS',
}

const UploadPoliciesData = [
  {
    insuranceType: UploadPolicyInsuranceTypes.health,
    label: 'Health Insurance',
    icon: Health_Insurance_Icon,
    redirectionUrl: 'health',
  },
  {
    insuranceType: UploadPolicyInsuranceTypes.car,
    label: 'Car Insurance',
    icon: Car_Insurance_Icon,
    redirectionUrl: 'motor',
  },
  {
    insuranceType: UploadPolicyInsuranceTypes.bike,
    label: 'Bike Insurance',
    icon: Bike_Insurance_Icon,
    redirectionUrl: 'bike',
  },
  {
    insuranceType: UploadPolicyInsuranceTypes.life,
    label: 'Term Life Insurance',
    icon: Life_Insurance_Icon,
    redirectionUrl: null,
  },
  {
    insuranceType: UploadPolicyInsuranceTypes.others,
    label: 'Other Policies',
    icon: null,
    redirectionUrl: null,
    hideBuy: true,
  },
]

const SmartBuyersList = [
  UploadPolicyInsuranceTypes.health,
  UploadPolicyInsuranceTypes.car,
  UploadPolicyInsuranceTypes.bike,
  UploadPolicyInsuranceTypes.life,
]

export { UploadPoliciesData, UploadPolicyInsuranceTypes, SmartBuyersList }

export const INSURANCE_TYPES = [
  {
    insuranceName: 'Health Insurance',
    logo: Health_Insurance_Icon,
    redirectionUrl: 'health',
    buyOptions: [
      {
        topUP: 'Top Up',
        criticalIllness: 'Critical Illness',
      },
    ],
    isDisabled: false,
  },
  {
    insuranceName: 'Car Insurance',
    logo: Car_Insurance_Icon,
    redirectionUrl: 'motor',
    buyOptions: [
      {
        regNo: 'No Reg. No?',
        policyExpired: 'Buying a New Car?',
        buyNewCar: 'Policy Expired?',
      },
    ],
    isDisabled: false,
  },
  {
    insuranceName: 'Bike Insurance',
    logo: BikeInsuranceLogo,
    redirectionUrl: 'bike',
    buyOptions: [
      {
        regNo: 'No Reg. No?',
        policyExpired: 'Buying a New Car?',
        buyNewCar: 'Policy Expired?',
      },
    ],
    isDisabled: false,
  },
  {
    insuranceName: 'Life Insurance',
    logo: LifeInsurance,
    redirectionUrl: 'life',
    buyOptions: [{}],
    isDisabled: false,
  },
  {
    insuranceName: 'Home Insurance',
    logo: HomeInsurance,
    redirectionUrl: '',
    buyOptions: [{}],
    isDisabled: true,
  },
  {
    insuranceName: 'Pet Insurance',
    logo: PetInsurance,
    redirectionUrl: '',
    buyOptions: [{}],
    isDisabled: true,
  },
  {
    insuranceName: 'Travel Insurance',
    logo: TravelInsurance,
    redirectionUrl: '',
    buyOptions: [{}],
    isDisabled: true,
  },
  {
    insuranceName: 'Accidental Insurance',
    logo: AccidentalInsurance,
    redirectionUrl: '',
    buyOptions: [{}],
    isDisabled: true,
  },
]

export const INSURANCE_SUB_TYPES = {
  TWO_WHEELER: 'Two-Wheeler',
  FOUR_WHEELER: 'Four-Wheeler',
}
